import {CurrentUtils} from "xmgoing-server";

export function useRoleAclHooks({roleAppConfigs,props}){
  const backFlag=ref(true);
  const hasCtlAlcFlag=computed(()=>{
    //存在角色应用授权
    if((unref(props).roleAppAcl+'')==='true'){
      return true;
    }
    //存在集团显示授权
    if((unref(props)['showFlagIsRoot']+'')==='true'){
      return true;
    }
    return  false;
  })


  /**
   * 获取角色应用授权信息 返回true为显示 返回false为不显示
   */
  const roleAppAclFlag=computed(()=>{
    if((unref(props)['showFlagIsRoot']+'')===true){
      CurrentUtils._loadUser(false, (userJson) => {
        if(userJson.accountId==="000000"){
          backFlag.value=true;
        }else{
          backFlag.value=false;
        }
      })
      return backFlag;
    }
    if((unref(roleAppConfigs)[unref(props).roleAppAclField]+'')===(unref(props).roleAppAclValue+'')){
      return  false;
    }
    return true;
  })
  return {
    hasCtlAlcFlag,
    roleAppAclFlag
  }
}
